import { FC, useCallback, useEffect, useMemo, useState } from 'react'
import RCSlider from 'rc-slider/lib/Slider'

import 'rc-slider/assets/index.css'
import { FORM_ELEMENTS } from '../types'

import * as SC from './styled'

export type SliderItem = {
  id: string
  label: string
}

export type SliderProps = {
  className?: string
  name: string
  items?: SliderItem[]
  value: string
  type?: FORM_ELEMENTS.SLIDER
  onChange: (name: string, value?: string) => void
  isForQuizz?: boolean
}

const Slider: FC<SliderProps> = (props) => {
  const { className, onChange, name, value, items = [], isForQuizz } = props
  const defaultValue = useMemo(() => {
    return items?.findIndex((i) => i.id === value)
  }, [value, items])
  const [currentValue, setCurrentValue] = useState(defaultValue)

  useEffect(() => {
    setCurrentValue(items?.findIndex((i) => i.id === value))
  }, [items, value])

  const handleSliderChange = useCallback(
    (newVal) => {
      setCurrentValue(newVal)
      const newItem = items?.[newVal]?.id ?? ''
      onChange?.(name, newItem)
    },
    [onChange, name, items]
  )

  const marks = useMemo(
    () =>
      items?.reduce(
        (obj, item, index) => ({
          ...obj,
          [index]: {
            label: item?.label,
          },
        }),
        {}
      ),
    [items]
  )

  return (
    <SC.Container className={className}>
      <SC.DesktopSlider currentValue={currentValue} isForQuizz={isForQuizz}>
        <RCSlider
          min={0}
          max={items?.length - 1}
          marks={marks}
          step={null}
          onChange={handleSliderChange}
          defaultValue={defaultValue}
          value={currentValue}
        />
      </SC.DesktopSlider>
      <SC.MobileSlider
        itemsNumber={items?.length ?? 0}
        currentValue={currentValue}
        isForQuizz={isForQuizz}
      >
        <RCSlider
          min={0}
          max={items?.length - 1}
          marks={marks}
          step={null}
          onChange={handleSliderChange}
          defaultValue={defaultValue}
          value={currentValue}
          vertical={!isForQuizz}
          reverse={!isForQuizz}
        />
      </SC.MobileSlider>
    </SC.Container>
  )
}

export default Slider
